import React from 'react';
import { FaPlay, FaEye, FaHeart } from 'react-icons/fa';

const Portfolio = () => {
  const projects = [
    {
      id: 1,
      thumbnail: 'https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?w=400',
      title: 'تصوير فيديوهات تفاعلية',
      description: 'أحدثنا ضجة لعملائنا بفيديوهات تيك توك إبداعية وصلت لملايين المشاهدات.',
      views: '3.2M',
      likes: '550K',
      category: 'إنتاج محتوى'
    },
    {
      id: 2,
      thumbnail: 'https://images.unsplash.com/photo-1611162618071-b39a2ec055fb?w=400',
      title: 'تحدي فيروسي ناجح',
      description: 'صممنا تحدي "الرقص الإماراتي" وشارك فيه آلاف المبدعين.',
      views: '6.7M',
      likes: '1.2M',
      category: 'تحدي فيروسي'
    },
    {
      id: 3,
      thumbnail: 'https://images.unsplash.com/photo-1516251193007-45ef944ab0c6?w=400',
      title: 'مونتاج احترافي',
      description: 'طورنا محتوى قنوات الطبخ بمونتاج سريع وجذاب يناسب تيك توك.',
      views: '2.1M',
      likes: '430K',
      category: 'مونتاج'
    },
    {
      id: 4,
      thumbnail: 'https://images.unsplash.com/photo-1557838923-2985c318be48?w=400',
      title: 'تيك توك على كل جهاز',
      description: 'ساعدنا العلامات التجارية تظهر على تيك توك من خلال استراتيجيات وصول ذكية.',
      views: '5.5M',
      likes: '980K',
      category: 'استراتيجية'
    },
    {
      id: 5,
      thumbnail: 'https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=400',
      title: 'محتوى تجميل احترافي',
      description: 'لمؤثرات التجميل: صورنا حملات مكياج مبهرة حققت تفاعل جماهيري.',
      views: '4.1M',
      likes: '720K',
      category: 'تجميل'
    },
    {
      id: 6,
      thumbnail: 'https://images.unsplash.com/photo-1520975916090-3105956dac38?w=400',
      title: 'مقابلات حصرية',
      description: 'نظمنا مقابلات مع مشاهير التيك توك زادت متابعيهم بالآلاف.',
      views: '3.8M',
      likes: '610K',
      category: 'مقابلات'
    }
  ];

  return (
    <section id="portfolio" className="py-5">
      <div className="container">
        <div className="text-center mb-5">
          {/* تم تغيير badge إلى bg-tiktok-cyan */}
          <span className="badge bg-tiktok-cyan text-black px-3 py-2 mb-3">PORTFOLIO</span>
          <h2 className="display-5 fw-bold mb-3">أعمالنا</h2>
          <p className="lead text-secondary">مشاريع ناجحة صنعناها لشركائنا</p>
        </div>

        <div className="row g-4">
          {projects.map((project, index) => (
            <div key={project.id} className="col-md-6 col-lg-4" data-aos="zoom-in" data-aos-delay={index * 100}>
              <div className="card border-0 shadow-sm h-100">
                <div className="position-relative">
                  <img 
                    src={project.thumbnail} 
                    className="card-img-top" 
                    alt={project.title}
                    style={{ height: '200px', objectFit: 'cover' }}
                  />
                  <div className="position-absolute top-50 start-50 translate-middle opacity-0 hover-show">
                    {/* تم تغيير bg-warning إلى bg-tiktok-cyan */}
                    <div className="bg-tiktok-cyan rounded-circle p-3">
                      <FaPlay className="text-black" />
                    </div>
                  </div>
                  {/* تم تغيير bg-warning إلى bg-tiktok-red */}
                  <span className="position-absolute top-0 end-0 bg-tiktok-red text-white px-2 py-1 m-2 rounded small">
                    {project.category}
                  </span>
                </div>
                <div className="card-body">
                  <h5 className="card-title fw-bold">{project.title}</h5>
                  <p className="card-text small text-secondary mb-3">{project.description}</p>
                  <div className="d-flex justify-content-between">
                    <span><FaEye className="me-1 text-secondary" /> {project.views}</span>
                    <span><FaHeart className="me-1 text-tiktok-red" /> {project.likes}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-5">
          {/* تم تغيير btn-outline-warning إلى btn-outline-tiktok-red مع كلاس مخصص */}
          <a href="#contact" className="btn btn-outline-tiktok-red btn-lg px-5">
            شوف المزيد من أعمالنا
          </a>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;